/**
 * Telas terminais do fluxo.
 *
 * Os frames `web-confirmacao` e `web-recusa` são o mesmo layout — ícone de 100px
 * num container circular, título, uma linha de apoio e o rodapé — mudando só
 * ícone e texto. Um componente com dois presets evita duplicar a estrutura.
 *
 * Não há ação de saída: o token já foi consumido e o spec §1 não prevê voltar ao
 * formulário.
 */

import styled from "styled-components";

import confirmationIcon from "assets/confirmation-icon.svg";
import refusalIcon from "assets/refusal-icon.svg";

import { PoweredByFooter } from "../components/PoweredByFooter";
import { Stack } from "../styled";
import { COLORS, MOBILE_MEDIA_QUERY } from "../tokens";
import { ExtensionOutcome } from "../types";

const OUTCOME_CONTENT: Record<
  ExtensionOutcome,
  { icon: string; title: string; description: string }
> = {
  CONFIRMED: {
    icon: confirmationIcon,
    title: "Extensão de plano confirmada",
    description:
      "Você confirmou que deseja manter seu plano os dados foram enviados para o RH.",
  },
  DECLINED: {
    icon: refusalIcon,
    title: "Recusa Confirmada",
    description: "Você confirmou que não deseja manter seu plano.",
  },
};

const Centered = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 80px 0;
  text-align: center;

  ${MOBILE_MEDIA_QUERY} {
    padding: 48px 0;
  }
`;

const Icon = styled.img`
  width: 100px;
  height: 100px;
`;

const OutcomeTitle = styled.h1`
  margin: 0;
  color: ${COLORS.ink};
  font-size: 28px;
  font-weight: 600;
  line-height: 133%;

  ${MOBILE_MEDIA_QUERY} {
    font-size: 22px;
  }
`;

const OutcomeDescription = styled.p`
  margin: 0;
  max-width: 480px;
  color: ${COLORS.inkMuted};
  font-size: 16px;
  line-height: 150%;

  ${MOBILE_MEDIA_QUERY} {
    font-size: 14px;
  }
`;

interface IProps {
  outcome: ExtensionOutcome;
}

export function OutcomeScreen({ outcome }: IProps) {
  const content = OUTCOME_CONTENT[outcome];

  return (
    <Stack $gap="0">
      <Centered>
        <Icon
          src={content.icon}
          alt=""
        />
        <OutcomeTitle>{content.title}</OutcomeTitle>
        <OutcomeDescription>{content.description}</OutcomeDescription>
      </Centered>
      <PoweredByFooter />
    </Stack>
  );
}
